// VueX 数据仓库
import Vuex from 'vuex'
import Vue from 'vue'
import moment from 'moment'

moment.locale('zh-CN')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userLoginInfo: {
      uid: localStorage.getItem('$$uid'), // '3077577722',
      createTime: '' // 1536021106000
    }
  },
  getters: {
    getUserLoginInfo: (state) => {
      return state.userLoginInfo;
    },
  },
  mutations: {
    updateUserLoginInfo (state, payload) {
      state.userLoginInfo = payload
    },
    clearUserLoginInfo (state) {
      state.userLoginInfo = {
        uid: '',
        createTime: ''
      }
    },
  }
})
